// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__Btn from "../../../html/Btn.js";
import * as Buhta_cabinet__Checkbox from "../../../html/Checkbox.js";
import * as Buhta_cabinet__Control from "../../../../grpc/Control.js";
import * as Buhta_cabinet__Dropdown from "../../../html/Dropdown.js";
import * as Buhta_cabinet__FormView from "../../../html/FormView.js";
import * as Buhta_cabinet__Kassa from "../../../../grpc/Kassa.js";
import * as Buhta_cabinet__ToastSender from "../../../../util/ToastSender.js";
import * as Buhta_components__LoadingDiv from "../../../../../../../packages/components/src/atoms/LoadingDiv.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../../../packages/core/lib/Toast.js";
import * as Cn from "../../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(etpId) {
  return function (onEtpSelect) {
    return function (disabledOpt) {
      const disabled = disabledOpt !== undefined ? disabledOpt : false;
      return function (etpNameOpt) {
        const etpName = etpNameOpt !== undefined ? etpNameOpt : "Выбрать из списка";
        const match = Buhta_core__GrpcState.useGrid(Buhta_cabinet__Control.EtpService.grid, undefined);
        const dispatch = match[1];
        const grid = match[0];
        React.useEffect((function () {
                Curry._3(dispatch, undefined, undefined, undefined);
              }), [etpId]);
        let etpName$1;
        if (typeof grid === "string" || grid.NAME !== "Data") {
          etpName$1 = "";
        } else {
          let tmp;
          try {
            tmp = Stdlib__List.find((function (etp) {
                    return etp.id === etpId;
                  }), grid.VAL);
          }
          catch (exn){
            tmp = {
              id: 0,
              key: "",
              name: etpName
            };
          }
          etpName$1 = tmp.name;
        }
        const match$1 = React.useState(function () {
              return false;
            });
        const setIsDropdownShown = match$1[1];
        const activator = function (param) {
          return JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: etpId === 0 || disabled ? "text-gray-medium" : "text-black",
                              children: etpName$1
                            }),
                        JsxRuntime.jsx("img", {
                              className: "w-5 h-5",
                              src: StaticAsset.src(disabled ? "/static/icons/select-arrows-gray-20.svg" : "/static/icons/select-arrows.svg")
                            }),
                        JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                              className: "absolute -top-2.5 left-2 bg-white px-2 text-gray-medium",
                              children: "ЭТП"
                            })
                      ],
                      className: "rounded border border-gray-main px-4 py-3 flex justify-between relative items-center"
                    });
        };
        return JsxRuntime.jsx(Buhta_cabinet__Dropdown.Custom.make, {
                    align: "BottomCenter",
                    activator: activator,
                    background: "bg-white",
                    isDropdownShown: disabled ? false : match$1[0],
                    setIsDropdownShown: setIsDropdownShown,
                    children: JsxRuntime.jsx("div", {
                          children: typeof grid === "string" || grid.NAME !== "Data" ? null : Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(grid.VAL, (function (index, etp) {
                                        const Key = "dt-" + String(index);
                                        return JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                          children: etp.name
                                                        }),
                                                    className: Cn.$plus("flex items-center space-x-2 px-4 py-1.5", "cursor-pointer  hover:bg-gray-light"),
                                                    onClick: (function (param) {
                                                        Curry._1(onEtpSelect, etp.id);
                                                        Curry._1(setIsDropdownShown, (function (param) {
                                                                return false;
                                                              }));
                                                      })
                                                  }, Key);
                                      }))),
                          className: "py-2 flex flex-col"
                        })
                  });
      };
    };
  };
}

function KkmSettingsEtp$EtpSelect(Props) {
  return Curry._2(make(Props.etpId)(Props.onEtpSelect), Props.disabled, Props.etpName);
}

const EtpSelect = {
  make: KkmSettingsEtp$EtpSelect
};

function make$1(id) {
  return function (onCreate) {
    const initialFocusRef = React.useRef(null);
    const match = Buhta_core__Tenant.useTenant(undefined);
    const tenant = match[0];
    const match$1 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
    const dispatchToasts = match$1[1];
    const match$2 = React.useState(function () {
          return 0;
        });
    const setEtp = match$2[1];
    const etpId = match$2[0];
    return JsxRuntime.jsxs(Buhta_cabinet__FormView.make, {
                onSubmit: (function (param) {
                    const formData = {
                      etp_id: etpId,
                      allow_ingress: false,
                      allow_egress: false
                    };
                    const __x = Buhta_cabinet__Kassa.KkmEtpService.create(tenant, id, formData);
                    $$Promise.get(__x, (function (result) {
                            if (result.TAG !== /* Ok */0) {
                              return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при отправке формы:");
                            }
                            Curry._1(onCreate, undefined);
                            Curry._1(dispatchToasts, {
                                  TAG: /* Add */0,
                                  _0: {
                                    id: Buhta_core__Toast.generateId(undefined),
                                    text: "ЭТП успешно сохранен",
                                    kind: "success",
                                    onClick: (function (param) {
                                        
                                      })
                                  }
                                });
                          }));
                  }),
                initialFocusRef: initialFocusRef,
                className: "px-4 lg:px-0 pt-6",
                children: [
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(KkmSettingsEtp$EtpSelect, {
                              etpId: etpId,
                              onEtpSelect: (function (value) {
                                  Curry._1(setEtp, (function (param) {
                                          return value;
                                        }));
                                })
                            }),
                        className: "bg-white lg:w-140.5 lg:px-10 p-6 rounded shadow-card"
                      }),
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                              title: "Сохранить",
                              className: "px-6 py-3",
                              type_: "submit"
                            }),
                        className: "lg:w-140.5 flex justify-end mt-6"
                      }),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("img", {
                                src: StaticAsset.src("/static/icons/info.svg")
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "text-gray-medium",
                                children: "После привязки, сбросить ЭТП возможно только через службу поддержки"
                              })
                        ],
                        className: "lg:w-140.5 flex items-center gap-1 mt-6"
                      })
                ]
              });
  };
}

function KkmSettingsEtp$NewEtpForm(Props) {
  return make$1(Props.id)(Props.onCreate);
}

const NewEtpForm = {
  make: KkmSettingsEtp$NewEtpForm
};

function make$2(id) {
  return function (etp) {
    return function (onUpdate) {
      const initialFocusRef = React.useRef(null);
      const match = Buhta_core__Tenant.useTenant(undefined);
      const tenant = match[0];
      const match$1 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
      const dispatchToasts = match$1[1];
      const match$2 = React.useState(function () {
            const info = etp.info;
            if (info !== undefined) {
              return info.id;
            } else {
              return 0;
            }
          });
      const setEtp = match$2[1];
      const match$3 = React.useState(function () {
            return etp.allow_ingress;
          });
      const setIngress = match$3[1];
      const ingress = match$3[0];
      const match$4 = React.useState(function () {
            return etp.allow_egress;
          });
      const setEgress = match$4[1];
      const egress = match$4[0];
      const info = etp.info;
      return JsxRuntime.jsxs(Buhta_cabinet__FormView.make, {
                  onSubmit: (function (param) {
                      const formData = {
                        allow_ingress: ingress,
                        allow_egress: egress
                      };
                      const __x = Buhta_cabinet__Kassa.KkmEtpService.update(tenant, id, formData);
                      $$Promise.get(__x, (function (result) {
                              if (result.TAG !== /* Ok */0) {
                                return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при отправке формы:");
                              }
                              Curry._1(onUpdate, undefined);
                              Curry._1(dispatchToasts, {
                                    TAG: /* Add */0,
                                    _0: {
                                      id: Buhta_core__Toast.generateId(undefined),
                                      text: "ЭТП успешно сохранен",
                                      kind: "success",
                                      onClick: (function (param) {
                                          
                                        })
                                    }
                                  });
                            }));
                    }),
                  initialFocusRef: initialFocusRef,
                  className: "px-4 lg:px-0 pt-6",
                  children: [
                    JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx(KkmSettingsEtp$EtpSelect, {
                                etpId: match$2[0],
                                onEtpSelect: (function (value) {
                                    Curry._1(setEtp, (function (param) {
                                            return value;
                                          }));
                                  }),
                                disabled: true,
                                etpName: info !== undefined ? info.name : ""
                              }),
                          className: "bg-white lg:w-140.5 lg:px-10 p-6 rounded shadow-card"
                        }),
                    tenant.ctx === /* AdminCtx */1 ? JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                    className: "text-default-gray",
                                    children: "Настройки администратора"
                                  }),
                              JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                    isChecked: ingress,
                                    onChange: (function (param) {
                                        Curry._1(setIngress, (function (param) {
                                                return !ingress;
                                              }));
                                      }),
                                    text: "Прием чеков от ЭТП",
                                    className: "mt-4"
                                  }),
                              JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                    isChecked: egress,
                                    onChange: (function (param) {
                                        Curry._1(setEgress, (function (param) {
                                                return !egress;
                                              }));
                                      }),
                                    text: "Обработка чеков",
                                    className: "mt-4"
                                  })
                            ],
                            className: "bg-white lg:w-140.5 px-10 py-6 mt-2 rounded shadow-card"
                          }) : null,
                    JsxRuntime.jsxs("div", {
                          children: [
                            tenant.ctx === /* AdminCtx */1 ? JsxRuntime.jsx("button", {
                                    children: JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                          children: "Сбросить ЭТП"
                                        }),
                                    className: "px-6 py-3 rounded border border-gray-main",
                                    onClick: (function (param) {
                                        const __x = Buhta_cabinet__Kassa.KkmEtpService.reset(tenant, id, undefined);
                                        $$Promise.get(__x, (function (result) {
                                                if (result.TAG !== /* Ok */0) {
                                                  return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при отправке формы:");
                                                }
                                                Curry._1(onUpdate, undefined);
                                                Curry._1(dispatchToasts, {
                                                      TAG: /* Add */0,
                                                      _0: {
                                                        id: Buhta_core__Toast.generateId(undefined),
                                                        text: "Настройки ЭТП сброшены",
                                                        kind: "success",
                                                        onClick: (function (param) {
                                                            
                                                          })
                                                      }
                                                    });
                                              }));
                                      })
                                  }) : JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("img", {
                                            src: StaticAsset.src("/static/icons/info.svg")
                                          }),
                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            className: "text-gray-medium",
                                            children: "Чтобы сбросить ЭТП, обратитесь в службу поддержки"
                                          })
                                    ],
                                    className: "flex items-center gap-1"
                                  }),
                            tenant.ctx === /* AdminCtx */1 ? JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                                    title: "Сохранить",
                                    className: "px-6 py-3",
                                    type_: "submit"
                                  }) : null
                          ],
                          className: "lg:w-140.5 flex justify-between mt-6"
                        })
                  ]
                });
    };
  };
}

function KkmSettingsEtp$UpdateEtpForm(Props) {
  return Curry._1(make$2(Props.id)(Props.etp), Props.onUpdate);
}

const UpdateEtpForm = {
  make: KkmSettingsEtp$UpdateEtpForm
};

function KkmSettingsEtp(Props) {
  let id = Props.id;
  const match = React.useState(function () {
        return 1;
      });
  const setNonce = match[1];
  const nonce = match[0];
  const func = Buhta_cabinet__Kassa.KkmEtpService.view;
  const match$1 = Buhta_core__GrpcState.useModel((function (param) {
          return Curry._3(func, param, /* [] */0, id);
        }), undefined);
  const dispatch = match$1[1];
  const kkm = match$1[0];
  React.useEffect((function () {
          Curry._2(dispatch, undefined, undefined);
        }), [
        id,
        nonce
      ]);
  if (typeof kkm !== "string" && kkm.NAME === "Data") {
    const etp = kkm.VAL;
    if (etp !== undefined) {
      return JsxRuntime.jsx(KkmSettingsEtp$UpdateEtpForm, {
                  id: id,
                  etp: etp,
                  onUpdate: (function (param) {
                      Curry._1(setNonce, (function (param) {
                              return -nonce | 0;
                            }));
                    })
                });
    } else {
      return JsxRuntime.jsx(KkmSettingsEtp$NewEtpForm, {
                  id: id,
                  onCreate: (function (param) {
                      Curry._1(setNonce, (function (param) {
                              return -nonce | 0;
                            }));
                    })
                });
    }
  }
  return JsxRuntime.jsx(Buhta_components__LoadingDiv.make, {});
}

const make$3 = KkmSettingsEtp;

export {
  EtpSelect ,
  NewEtpForm ,
  UpdateEtpForm ,
  make$3 as make,
}
/* Buhta_cabinet__Btn Not a pure module */
